import classNames from "classnames";
import moment from "moment";
import React from "react";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2E1 } from "../../../../../redux/app/bfl-2/groups/bfl2-e";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2E1PreviewProps = OwnProps;
function BFL2E1Preview(props: BFL2E1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2E1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "E", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, 3, renderItem3()],
					[null, null, 4, renderItem4()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item1.locationWhereShipConductProactiveCleaning
					? biofoulingRecord.item1.locationWhereShipConductProactiveCleaning
					: "-----"}
			</h4>
		);
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item2.contigencyActions
					? biofoulingRecord.item2.contigencyActions
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<>
				<h4 className="font-medium uppercase">
					{biofoulingRecord.item3.recordsOfMaintenance
						? biofoulingRecord.item3.recordsOfMaintenance
						: "-----"}
				</h4>
				{biofoulingRecord.item3.maintenanceAttachment != " " ? (
					<h3 className="font-medium uppercase">
						Attachment: {biofoulingRecord.item3.maintenanceAttachment}
					</h3>
				) : null}
			</>
		);
	}
	function renderItem4() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item4.dateWhenShipReturnedToNormal
					? `${moment(
							biofoulingRecord.item4.dateWhenShipReturnedToNormal
					  ).format("DD-MMM-YYYY")} (SMT)`
					: "-----"}
			</h4>
		);
	}

	return renderMain();
}

export default BFL2E1Preview;
